import { render } from "./ConversationComponent.vue?vue&type=template&id=6c4635c2&scoped=true"
import script from "./ConversationComponent.vue?vue&type=script&lang=js"
export * from "./ConversationComponent.vue?vue&type=script&lang=js"

import "./ConversationComponent.vue?vue&type=style&index=0&id=6c4635c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4635c2"]])

export default __exports__